import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const CLINIC = {
  name: "Clínica Dental Pina",
  address: "Vilamar 70, Esc. A, Bjs. 7",
  city: "43820 Calafell Platja",
  province: "Tarragona",
  email: "calafell.pina@hotmail.com",
  phone: "+34 977 691 550",
  phoneDisplay: "977 691 550",
  whatsapp: "34608156491",
  whatsappDisplay: "608 156 491",
  hours: [
    { day: "Lunes", time: "10:00 - 13:00 / 14:00 - 18:00" },
    { day: "Martes", time: "10:00 - 13:00 / 14:00 - 18:00" },
    { day: "Miércoles", time: "10:00 - 14:00" },
    { day: "Jueves", time: "10:00 - 13:00 / 14:00 - 18:00" },
    { day: "Viernes", time: "10:00 - 14:00" },
  ],
  mapsUrl: "https://maps.google.com/?q=Vilamar+70+Calafell+Platja",
};

const ASSET_BASE = "https://customer-assets.emergentagent.com/job_clinica-calafell-v2/artifacts";

export const IMG = {
  doctors: {
    pinaRamon: `${ASSET_BASE}/qeecfr43_DR.%20FRANCISCO%20PINA%20RAMON.jpg`,
    pinaAdell: `${ASSET_BASE}/d2zykbtp_DR.%20FRANCISCO%20PINA%20ADELL.jpg`,
    pabloPina: `${ASSET_BASE}/yi64nkw8_DR.%20PABLO%20PINA%20ADELL.jpg`,
    iris: `${ASSET_BASE}/9oi8ezpt_DRA.%20IRIS%20LADRON%20DE%20GUEVARA.jpg`,
  },
  clinic: {
    interior1: `${ASSET_BASE}/yeaa66bv_20210226_144429.jpg`,
    interior2: `${ASSET_BASE}/wkh17088_20210226_150059.jpg`,
    xray: `${ASSET_BASE}/2ihhy41v_20210226_150112.jpg`,
    sign: `${ASSET_BASE}/o2bmjvfk_20210226_150230.jpg`,
  },
  treatments: {
    implantes: `${ASSET_BASE}/udrg6esx_IMPLANTES.JPG`,
    ortodoncia: `${ASSET_BASE}/yc248g6y_ORTODONCIA%20INVISIBLE.jpg`,
    estetica: `${ASSET_BASE}/up6re7yq_EST%C3%89TICA%20DENTAL.jpg`,
    odontopediatria: `${ASSET_BASE}/til4mo80_odontopediatria.jpg`,
    urgencias: `${ASSET_BASE}/62d9c61f_URGENCIAS%20DENTALES.jpg`,
  },
};
